import script from "./SemesterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SemesterComponent.vue?vue&type=script&setup=true&lang=js"

import "vue-scroll-picker/lib/style.css?vue&type=style&index=0&lang=css"
import "./SemesterComponent.vue?vue&type=style&index=1&id=3553ce18&lang=css"

const __exports__ = script;

export default __exports__